import { render, staticRenderFns } from "./TableStick.vue?vue&type=template&id=4f2ba9bd&scoped=true"
import script from "./TableStick.vue?vue&type=script&lang=js"
export * from "./TableStick.vue?vue&type=script&lang=js"
import style0 from "./TableStick.vue?vue&type=style&index=0&id=4f2ba9bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ba9bd",
  null
  
)

export default component.exports